<script>
import ConfirmTab from "./ConfirmTab.vue"
import {mapState} from "vuex";
import ConfirmDialog from "./ConfirmDialog.vue";
import danApi from "../../api/danApi";

export default {
  name: "ConfirmTabs",
  components: {ConfirmDialog, ConfirmTab},
  computed: {
    ...mapState('user', ['user', 'danState', 'danResultLoading']),
    danConfirmed() {
      return (this.user.individual === 'children' || this.user.individual === 'company') || !!this.user.dan_verified || this.danState
    }
  },
  data() {
    return {
      showDialog: false,
    }
  },
  methods: {
    openDialog() {
      this.showDialog = true
    },
    closeDialog() {
      this.showDialog = false
    },
    success() {
      this.showDialog = false
      this.$store.dispatch('user/fetchUser')
    },
    async redirectToDan() {
      const {data} = await danApi.getGrantUrl()

      window.location.href = data;
    },
  },
}

</script>
<template>
  <div v-if="this.user" class="confirm-container">
    <confirm-dialog :show="showDialog" @close="closeDialog" @success="success"/>
    <confirm-tab :confirmed="!!this.user.email">
      <h4 class="card-title">{{ $t('kyc.confirm.email') }}</h4>
      <p class="card-text success"><span>{{ this.user.email }}</span></p>
      <ic-button class="card-button" size="tn" :disabled="true">
        <template>
          {{ $t('kyc.confirm.verified') }}
        </template>
      </ic-button>
    </confirm-tab>
    <confirm-tab :confirmed="!!this.user.mobilenumber">
      <h4 class="card-title">{{ $t('kyc.confirm.phone') }}</h4>
      <p class="card-text success" v-if="!!this.user.mobilenumber"><span
          style="color: var(--gray-color-new)">(+976)</span> {{ this.user.mobilenumber }}</p>
      <p class="card-text" v-else>{{ $t('kyc.confirm.phone_not_found') }}</p>
      <ic-button class="card-button" size="tn" :disabled="false" @click="openDialog">
        <template v-if="this.user.mobilenumber">
          {{ $t('registration.change-phone') }}
        </template>
        <template v-else>
          {{ $t('kyc.confirm.verify') }}
        </template>
      </ic-button>
    </confirm-tab>
    <confirm-tab :confirmed="danConfirmed">
      <h4 class="card-title">{{ $t('user.info') }}</h4>
      <img v-if="danConfirmed" src="/img/emongolia_blue.svg"
           style="display: block; margin-left: auto; margin-right: auto" height="17"/>
      <p v-else class="card-text">{{ $t('kyc.confirm.unverified') }}</p>
      <ic-button class="card-button" :class="{'p-0 mt-6': !danConfirmed}" size="tn" :disabled="danConfirmed"
                 :loading="danResultLoading" @click="redirectToDan">
        <template v-if="danConfirmed">
          {{ $t('kyc.confirm.verified') }}
        </template>
        <template v-else>
          <img src="/img/emongolia_blue.svg" style="display: block" height="29"/>
        </template>
      </ic-button>
    </confirm-tab>
  </div>
</template>

<style scoped lang="scss">
.confirm-container {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 36px;
  padding: 22px 22px;
}

@media (max-width: 1300px) {
  .confirm-container {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 1080px) {
  .confirm-container {
    grid-template-columns: 1fr;
  }
}
</style>